const API_BASE_URL: string = import.meta.env.REACT_APP_API_BASE_URL ?? "";

export default API_BASE_URL;
